import axios, { AxiosRequestConfig } from 'axios'
import store from '@/redux'
import { removeToken } from '@/redux/userSlice'
import { Message } from '@/components/message'
import { message } from 'antd'
import { getQueryParameter } from '@/utils'

const color = getQueryParameter(window.location.href, 'color') || ''
const isDev = process.env.NODE_ENV === 'dev'
interface Request {
  <P, R>(url: string, params?: P, data?: P, config?: AxiosRequestConfig): Promise<R>
}
const request = axios.create({
  baseURL: isDev ? '/api' : '/',
  timeout: 5000,
})

// 添加请求拦截器
request.interceptors.request.use(
  function (config) {
    if (/get/i.test(config.method || 'get')) {
      //判断get请求
      config.params = config.params || {}
      config.params.t = Date.parse(String(new Date())) / 1000 //添加时间戳
    }

    // 在发送请求之前做些什么
    const tokens = localStorage.getItem('token')
    const subTokens = localStorage.getItem('subToken')

    // 初始化headers对象
    if (!config.headers) {
      config.headers = {}
    }

    // 设置默认Content-Type
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json'
    }

    if (tokens) {
      try {
        const { id, token } = JSON.parse(tokens)
        if (color) {
          Object.assign(config.headers, {
            token,
            'user-id': id,
            'x-color': color || 'wp',
          })
        } else {
          Object.assign(config.headers, {
            token,
            'user-id': id,
          })
        }
      } catch (error) {}
    }
    if (subTokens) {
      try {
        const { id, token } = JSON.parse(subTokens)
        if (color) {
          Object.assign(config.headers, {
            'X-Subuser-Token': token,
            'X-Subuser-ID': id,
            'x-color': color || 'wp',
          })
        } else {
          Object.assign(config.headers, {
            'X-Subuser-Token': token,
            'X-Subuser-ID': id,
          })
        }
      } catch (error) {}
    }
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
)

// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    const { data } = response

    // 如果是blob响应，直接返回完整响应对象
    if (response.config.responseType === 'blob' && !response.config.isComplete) {
      return response
    }

    if (data.code !== 200) {
      switch (data.code) {
        case 401:
          console.log('返回bas401')
          store.dispatch(removeToken())
          break
        case 429:
          Message.error('访问频率过快')
          break
        case 503:
          window.location.replace('/maintenance')
          break
        default:
          break
      }
      return Promise.reject(data)
    }
    return data
  },
  function (error) {
    console.log('error?.response?.status', error)
    switch (error?.response?.status) {
      case 429:
        Message.error('访问频率过快')
        break
      case 401:
        message.destroy()
        Message.error('用户未登录')
        store.dispatch(removeToken())
        break
      case 503:
        window.location.replace('/maintenance')
        break
      default:
        Message.error('目标网站不可达')
        break
    }

    // 对响应错误做点什么
    // return Promise.reject({ msg: '目标网站不可达', code: 500 })
  },
)

const get = function (url, params?) {
  return request({
    url,
    params,
    method: 'GET',
  })
} as Request

const post = function (url, data?) {
  return request({
    url,
    data,
    method: 'POST',
  })
} as Request

const put = function (url, data?) {
  return request({
    url,
    data,
    method: 'PUT',
  })
} as Request
const deletes = function (url, data?) {
  return request({
    url,
    data,
    method: 'DELETE',
  })
} as Request

export { request, get, post, put, deletes }
